import axios from 'axios'
import env from './env'
import router from '../router'
import Vue from 'vue'
import { Promise } from 'core-js'
import Nprogress from 'nprogress'
import qs from 'qs'

// 创建多个axios实例，支持不同域名和token
class MultiRequestService {
  constructor () {
    this.instances = new Map()
    this.defaultConfig = {
      timeout: 30000,
      showLoading: true
    }
  }

  // 获取或创建axios实例
  getInstance (config = {}) {
    const {
      baseURL = env.wechatWebIP,
      tokenKey = 'Authorization',
      customHeaders = {}
    } = config

    const instanceKey = `${baseURL}_${tokenKey}`

    if (!this.instances.has(instanceKey)) {
      const instance = axios.create({
        baseURL,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8;',
          ...customHeaders
        },
        timeout: this.defaultConfig.timeout,
        showLoading: this.defaultConfig.showLoading
      })

      // 请求拦截器
      instance.interceptors.request.use(
        config => {
          if (config.showLoading) {
            Vue.$showLoading.show()
            Nprogress.start()
          }

          // 根据tokenKey获取对应的token
          const token = localStorage.getItem(tokenKey)
          if (token) {
            // 如果是WX_TOKEN，添加到请求体中
            if (tokenKey === 'WX_TOKEN') {
              if (config.method === 'get') {
                // config.params = { ...config.params, token }
                config.headers.Authorization = token
              } else {
                console.log('config.data', config)
                // config.headers[tokenKey] = token
                config.headers.Authorization = token
              }
            } else {
              // 其他token添加到请求头
              config.headers.Authorization = token
            }
          }

          if (config.method === 'get') {
            config.paramsSerializer = function (params) {
              return qs.stringify(params, { arrayFormat: 'repeat' })
            }
          }

          return config
        },
        error => {
          Vue.$showLoading.hide()
          Nprogress.done()
          return Promise.reject(error)
        }
      )

      // 响应拦截器
      instance.interceptors.response.use(
        (res) => {
          Nprogress.done()
          Vue.$showLoading.hide()

          if (res.status && res.status === 200) {
            // 保存新的token
            if (res.headers && res.headers.authorization) {
              const authorization = res.headers.authorization
              localStorage.setItem(tokenKey, authorization)
            }

            if (res.data.code === 200) {
              return res.data
            } else if (res.data.code === 2014) {
              const href = window.location.href
              if (href.includes('stuLogin')) {
                return Promise.resolve(res.data)
              } else {
                Vue.prototype.$confirm('您有未完善的信息，是否现在去完善?', '提示', {
                  confirmButtonText: '去完善',
                  cancelButtonText: '取消',
                  type: 'warning',
                  center: true
                }).then(() => {
                  router.push({
                    path: '/cebsbUserInfo?pushUrl=/speRegisterFirCompetition'
                  })
                }).catch(() => {
                })
              }
            } else if (res.data.code === 401) {
              Vue.prototype.$message.error('登录已过期，请重新登录！')
              localStorage.removeItem(tokenKey)

              if (localStorage.getItem('isStu')) {
                router.push({
                  path: '/stuLogin',
                  params: { pushUrl: '' }
                })
              } else {
                router.push({
                  path: '/login',
                  params: { pushUrl: '' }
                })
              }
            } else {
              Vue.prototype.$message.error(res.data.msg)
            }
            return Promise.reject(res)
          }
        },
        err => {
          Vue.$showLoading.hide()
          Nprogress.done()
          console.log('err', err)

          if (err.code === 'ERR_BAD_RESPONSE') {
            if (err.response.data.code === 401) {
              Vue.prototype.$message.error('登录已过期，请重新登录！')
              localStorage.removeItem(tokenKey)

              if (localStorage.getItem('isStu')) {
                router.push({
                  path: '/stuLogin',
                  params: { pushUrl: '' }
                })
              } else {
                router.push({
                  path: '/login',
                  params: { pushUrl: '' }
                })
              }
            }
          } else {
            if (err.status === 401) {
              Vue.prototype.$message.error('登录已过期，请重新登录！')
              localStorage.removeItem(tokenKey)

              if (localStorage.getItem('isStu')) {
                router.push({
                  path: '/stuLogin',
                  params: { pushUrl: '' }
                })
              } else {
                router.push({
                  path: '/login',
                  params: { pushUrl: '' }
                })
              }
            }
          }
          return Promise.reject(err)
        }
      )

      this.instances.set(instanceKey, instance)
    }

    return this.instances.get(instanceKey)
  }

  // 创建默认实例（使用原有配置）
  getDefaultInstance () {
    return this.getInstance({
      baseURL: env.baseIP,
      tokenKey: 'Authorization'
    })
  }

  // 创建WX_TOKEN实例（用于semiThirdRound等页面）
  getWxInstance () {
    return this.getInstance({
      baseURL: env.wechatWebIP,
      tokenKey: 'WX_TOKEN'
    })
  }

  // 创建自定义实例
  createCustomInstance (config) {
    return this.getInstance(config)
  }
}

// 创建全局实例
const multiRequestService = new MultiRequestService()

// 导出默认实例（保持向后兼容）
const defaultInstance = multiRequestService.getDefaultInstance()

// 导出WX_TOKEN实例
const wxInstance = multiRequestService.getWxInstance()

// 导出服务类
export { multiRequestService, defaultInstance, wxInstance }

// 默认导出默认实例（保持原有API兼容性）
export default defaultInstance
